module.exports = __webpack_public_path__ + "img/company-auth-img.a2b0f609.png";